export default "__VITE_ASSET__c01a89a7__"